import { InviteStatus } from 'src/@types/userOrg';

export const orgTabLabels: Record<InviteStatus, string> = {
  [InviteStatus.Accepted]: 'Accepted',
  [InviteStatus.Pending]: 'Pending',
  [InviteStatus.Rejected]: 'Rejected',
};

export const orgSwitcherTabs: InviteStatus[] = [
  InviteStatus.Accepted,
  InviteStatus.Pending,
  InviteStatus.Rejected,
];
